import LegalPage from './LegalPage';
const TermsOfService = () => <LegalPage pageKey="terms" />;
export default TermsOfService;
